import { Component, OnInit } from '@angular/core';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { NotificationGridComponent } from '../notificationgrid.component';

@Component({
    providers: ServiceBagServices,
    selector: 'app-sms-history-grid',
    templateUrl: './sms-history-grid.component.html',
    styleUrls: ['./sms-history-grid.component.scss']
})
export class SmsHistoryGridComponent extends NotificationGridComponent {

    constructor(A: ServiceBagService) {
        super(A, 'SmsHistoryGridComponent');
    }
}
